import { ReactSVG } from "react-svg";
import InfoIcon from "../../shared/icon/Info.svg";
import Tooltip from "./Tooltip";
import { setSVGColor } from "shared/SVGHelper";

const ICON_WIDTHS = Object.freeze({
    xs: "12px",
    sm: "16px",
    md: "20px",
    lg: "24px",
    xl: "32px",
    "2xl": "48px",
});

/**
 * @typedef {object} InfoIconWithTooltipOptions
 * @property {"xs" | "sm" | "md" | "lg" | "xl" | "2xl"} size Size of the icon. Defaults to "md".
 */

/**
 * Info icon that displays a tooltip when hovered over.
 * @param {Omit<import("./Tooltip").TooltipProps, "children"> & InfoIconWithTooltipOptions} props
 */
function InfoIconWithTooltip({ id, content, size = "md", iconColor, ...restProps }) {
    return (
        <Tooltip id={id} content={content} {...restProps}>
            <ReactSVG
                src={InfoIcon}
                beforeInjection={(svg) => {
                    svg.setAttribute("style", `width: ${ICON_WIDTHS[size]}; height: auto;`);
                    if (iconColor) setSVGColor(iconColor)(svg);
                }}
                onError={(error) => {
                    console.error(error);
                }}
            />
        </Tooltip>
    );
}

export default InfoIconWithTooltip;
